/**
 * URL Constants
 */

export const ROUTE_SYSTEM_ACCESS = '/SystemAccess';
export const ROUTE_ERROR_401 = '/SystemAccess';
export const ROUTE_SIGN_IN_OIDC = '/signin-oidc';

/** Logged Incident Notification */
export const ROUTE_HOMEPAGE = '/PSNotification';
export const ROUTE_INCIDENT_NOTIFICATION = '/PSNotificationIncident';
export const ROUTE_INCIDENT_NOTIFICATION_SEARCH = '/PSNotificationSearch';

/** Public Incident Notification */
export const ROUTE_PUBLIC_HOMEPAGE = '/Public' + ROUTE_HOMEPAGE;
export const ROUTE_PUBLIC_INCIDENT_NOTIFICATION =
  '/Public' + ROUTE_INCIDENT_NOTIFICATION;
export const ROUTE_PUBLIC_INCIDENT_NOTIFICATION_SEARCH =
  '/Public' + ROUTE_INCIDENT_NOTIFICATION_SEARCH;

/** Pharmacy Notification */
export const ROUTE_PHARMACY_HOMEPAGE = `/PSNotificationPharmacy`;
export const ROUTE_PUBLIC_PHARMACY_HOMEPAGE =
  '/Public' + ROUTE_PHARMACY_HOMEPAGE;
export const ROUTE_PHARMACY_NOTIFICATION = `/PSNotificationPharmacyInterventions`;
export const ROUTE_PUBLIC_PHARMACY_NOTIFICATION =
  '/Public' + `/PSNotificationPharmacyInterventions`;
export const ROUTE_PHARMACY_SEARCH = `/PSNotificationSearch`;

/** Classification and config */
export const ROUTE_UNIT = '/PSUnitSettings';
export const ROUTE_USER = '/PSUserSettings';
export const ROUTE_MESSAGE = '/PSMessageSettings';
export const ROUTE_PROFESSIONAL = '/PSProfessionalSettings';
export const ROUTE_IRAS_AUTOMATION = '/PSIRASAutomationSettings';
export const ROUTE_USER_DATA = '/PSContactSettings';
export const ROUTE_INVESTIGATION_TOOLS_SETTINGS =
  '/PSInvestigationToolsSettings';
export const ROUTE_LOGS = '/PSLogsSettings';

//classification
export const ROUTE_CLASSIFICATION_NOTIFICATION_MANAGEMENT =
  '/PSNotificationManagement';
export const ROUTE_CLASSIFICATION_NOTIFICATION_CLUESTERED_MANAGEMENT =
  '/PSClustering';
